<template>
  <div class="body">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="ql-container ql-snow">
      <p class="agreement ql-editor" v-html="pageInfo"></p>
    </div>
  </div>

</template>

<script>
import {apiPageInfo} from "@/request/API";
import breadcrumb from "@/components/breadcrumb";
export default {
  name: "agreement",
  components:{breadcrumb},
  data(){
    return {
      breadcrumbList: [
        {link: 'AllGame', name: '全部游戏'},
        {name: '购买协议'}
      ],
      pageInfo:'',
      id:this.$route.query.id
    }
  },
  methods:{
    getPageInfo(){
      apiPageInfo({
        id:this.id
      }).then(res=>{
        this.pageInfo = res.data.content
      })
    },
  },
  watch:{

  },
  created() {
  },
  mounted() {
    this.getPageInfo()
  }
}
</script>

<style scoped lang="less">
.body{
  width: 1200px;
}

</style>
<style  scoped>
.ql-container{
  border: none !important;
}
.agreement{
  padding: 0;
  /*width: 871px;*/
  overflow: auto;
  margin: 38px 0 0 ;
}
.agreement >>> img{
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}

</style>
